import React from "react";
import ReactDOM from "react-dom";

import NextApp from "./NextApp";
import * as serviceWorker from "./registerServiceWorker";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import installDevToolsGuard from "./util/devToolsGuard";

if (process.env.NODE_ENV === "production") {
  //  console.log = () => {}
  console.error = () => {};
  console.debug = () => {};
}
installDevToolsGuard();
ReactDOM.render(<NextApp />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
